import styled from 'styled-components'

import { hexToRgbA } from '@util/stringUtil'

export const Container = styled.div`
  display: inherit;
  border-radius: 24px;
  padding: 4px 8px;
  background-color: ${({ color }) => hexToRgbA(color, '0.10')};

  @media (max-width: 455px) {
    padding: 2px 6px;
  }
`

export const Text = styled.div`
  color: ${({ color }) => color};
  font-family: Circular-Std-Bold;

  @media (max-width: 455px) {
    font-size: 12px;
  }
`
